import useWS from '@/utils/ws';

export default (function (connect, share, uri) {
  const { data, activeClose, sendMessage, connectionStatus } = useWS({
    url: 'push?uri=' + uri,
    connect,
    share: share,
  });

  return [data ? data[0] || {} : {}, sendMessage, connectionStatus, activeClose];
});
